// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customEquip .q-field__native .q-field__control {\n  border: 0 !important;\n  padding: 0px !important;\n}\n.customEquip .q-field__native .custom-editing-input {\n  line-height: 18px !important;\n  padding: 0 !important;\n  border: 0;\n}\n.customEquip .q-field__native .custom-editing-input:focus {\n  border: 0 !important;\n  outline: none;\n}", ""]);
// Exports
module.exports = exports;
